import TextField from '@mui/material/TextField'
import MenuItem from '@mui/material/MenuItem'
import styles from './styles.module.css'

interface DropdownFilterProps {
  value: string
  onChange: (value: string) => void
  items: Array<{ key: string; value: string }>
  placeholder?: string
  disabled?: boolean
}

function DropdownFilter({
  value,
  onChange,
  items,
  placeholder = 'Default (all)',
  disabled,
}: DropdownFilterProps) {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value)
  }

  const data = [{ key: '', value: placeholder }].concat(items)

  const menutItems = data
    .filter(Boolean)
    .map(({ key, value: displayValue }) => {
      return (
        <MenuItem
          key={key}
          value={key}
          className={styles.dropDownOption}
        >
          {displayValue}
        </MenuItem>
      )
    })

  return (
    <div>
      <TextField
        className={styles.dropDownSelect}
        select
        fullWidth
        size='small'
        value={value}
        onChange={handleChange}
        disabled={disabled}
        slotProps={{
          select: {
            displayEmpty: true,
            sx: {
              fontWeight: 'bold',
              textAlign: 'left',
              color: value === '' ? 'var(--filter-placeholder)' : 'inherit',
            },
          },
        }}
        sx={{
          minWidth: '100px',
          maxWidth: '200px',
          display: 'flex',
          justifyContent: 'flex-start',
          backgroundColor: 'var(--filter-bg)',
          height: '35px',
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
        }}
      >
        {menutItems}
      </TextField>
    </div>
  )
}

export default DropdownFilter
